var map = {
	"./": 652,
	"./development": 4128,
	"./development.js": 4128,
	"./index": 652,
	"./index.js": 652,
	"./local": 9929,
	"./local.js": 9929,
	"./production": 3986,
	"./production.js": 3986,
	"./staging": 8865,
	"./staging.js": 8865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8391;